export default {
    GAME: {
        ONE_LINE: "ONE_LINE",
        TWO_LINE: "TWO_LINE",
        FULL_HOUSE: "FULL_HOUSE",
        JACKPOT: "JACKPOT"
    }
}